import styled from "styled-components";

import theme from "config/theme";

import { ButtonSimple } from "components/Button";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  text-align: center;
`;

export const SocialLinks = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 5px auto 35px;

  a {
    margin: 8px;
    transition: ${theme.transition};
    font-size: ${theme.font.size.theta};
    color: ${theme.color.gray3};

    &:hover {
      opacity: 0.7;
      color: ${theme.color.primary};
    }
  }
`;

export const EmailLink = styled(ButtonSimple)`
  margin: 0 auto 20px;
  color: ${theme.color.gray3};
  font-size: ${theme.font.size.theta};
`;
